import { HasKind } from '@/utilities/HasKind';

import { Crumbs } from '../bakery/Crumbs';

export const kind = 'SelectBorer';

export interface SelectBorer extends HasKind<typeof kind> {
  borerSelected: boolean;
}

export function crumble(action: SelectBorer): Crumbs {
  return {
    borerSelected: action.borerSelected,
  };
}
